// Parallax for media image


let lastKnownScrollPosition = 0;
let ticking = false;

function updateParallax() {
  parallaxMedias.forEach((element,index) => {
    /*let rect = element.getBoundingClientRect();

    if(rect.top <= window.innerHeight && rect.top*-1 <= rect.height){

      let percent = rect.top*100 / rect.height;
      let translate = percent*12/100 * -1;
      console.log('TEST',percent, translate);

      //element.querySelector('img').style.webkitTransform = 'scale(1.4) translateY(' + translate + '%)';
      //element.querySelector('img').style.transform = 'scale(1.4) translateY(' + translate + '%)';

    }//*/
    moveImage(element);

  });

}
function moveImage(element){
  let image = element.querySelector('img');

  if(!image.complete){
    setTimeout(moveImage,50,element);
  }

  let rect = element.getBoundingClientRect();

  if(rect.top <= window.innerHeight && rect.top*-1 <= rect.height){

    let percent = rect.top*100 / rect.height;
    let translate = percent*12/100 * -1;

    //image.style.webkitTransform = 'scale(1.4) translateY(' + translate + '%)';
    //image.style.transform = 'scale(1.4) translateY(' + translate + '%)';

  }

}

const parallaxMedias = document.querySelectorAll('.media.image')
if (parallaxMedias.length > 0) {
  // Initial setup : add the transform for the 1st img before scrolling
  updateParallax();
  //parallaxMedias[0].querySelector('img').style.webkitTransform = 'scale(1.4)';
  //parallaxMedias[0].querySelector('img').style.transform = 'scale(1.4)';

  // Update on scroll
  document.addEventListener('scroll', (ev) => {
    lastKnownScrollPosition = window.scrollY;

    if (!ticking) {
      window.requestAnimationFrame(() => {
        updateParallax();
        ticking = false;
      });

      ticking = true;
    }
  });
}
